import moment from "moment/moment";

export const formatDate = (dateString, format = "DD.MM.YYYY") => {
    return moment(dateString).format(format );
}
